import { useContext, useEffect, useState } from "react";
import Modal from "@components/modal/Modal.component";
import Button from "@components/common/Button.component";
import { walletContext } from "@src/core/context/walletContext";
import { WALLET_TYPE } from "@enum/walletType.enum";

const LedgerAddressModal = ({
  isVisible,
  onClose,
  isAddressLoading,
  onNext,
  onPrevious,
  firstPage,
  onConfirm,
  currentPage,
  addressList,
  walletPaths,
  setConnectWalletPopup,
}: any) => {
  const [active, setActive] = useState("");
  const [activePath, setActivePath] = useState("");

  const walletContextValue = useContext(walletContext);

  const handleSelect = (item: any, index: any) => {
    setActive(item);
    setActivePath(walletPaths[index]);
  };

  const onConfirmation = () => {
    onClose();
    onConfirm(active, activePath);
    setActive("");
    setActivePath("");
    walletContextValue.type = WALLET_TYPE.LEDGER;
    setConnectWalletPopup(false);
  };

  const onCloseHandler = () => {
    onClose();
    setActive("");
    setActivePath("");
  };

  return (
    <Modal setPopupOpen={isVisible} title="Select Address">
      <div className="ledger-wrapper">
        <div className="body ledger-address-body">
          <ul className="ledger-address-list">
            {!isAddressLoading ? (
              addressList.map((item: any, index: any) => (
                <li
                  className={`address-container ${
                    active === item ? "active" : ""
                  }`}
                  key={index}
                  tabIndex={0}
                  onClick={() => handleSelect(item, index)}
                >
                  <p className="col-10  text-truncate mb-0">
                    <span className="address-text">{item}</span>
                  </p>
                </li>
              ))
            ) : (
              <p className="address-text">Fetching addresses...</p>
            )}
          </ul>
        </div>

        {!isAddressLoading && (
          <>
            <nav aria-label="Page navigation">
              <ul className="pagination">
                <li className="page-item">
                  <button
                    className="page-link"
                    aria-label="Previous"
                    onClick={onPrevious}
                    disabled={currentPage == 1}
                    style={{ width: "40px", height: "30px" }}
                  >
                    <span aria-hidden="true">&laquo;</span>
                  </button>
                </li>
                <li className="page-item">
                  <button
                    className="page-link"
                    onClick={firstPage}
                    style={{ width: "40px", height: "30px" }}
                  >
                    {currentPage}
                  </button>
                </li>

                <li className="page-item">
                  <button
                    className="page-link"
                    aria-label="Next"
                    onClick={onNext}
                    style={{ width: "40px", height: "30px" }}
                  >
                    <span aria-hidden="true">&raquo;</span>
                  </button>
                </li>
              </ul>
            </nav>
            <div className="button-group-ledger">
              <Button
                fullWidth
                style={{ width: "150px" }}
                onClick={onConfirmation}
              >
                Confirm
              </Button>

              <Button
                fullWidth
                style={{ width: "150px" }}
                onClick={onCloseHandler}
              >
                Cancel
              </Button>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};

export default LedgerAddressModal;
